import { render, staticRenderFns } from "./roles_table.vue?vue&type=template&id=315206ed&lang=pug&"
import script from "./roles_table.vue?vue&type=script&lang=coffee&"
export * from "./roles_table.vue?vue&type=script&lang=coffee&"
import style0 from "./roles_table.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports